"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecentEntityList = exports.RecentEntityListDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var lodash_1 = require("lodash");
var loader_1 = require("../elements/loader");
var entity_list_1 = require("./entity-list");
var badge_divider_1 = require("../elements/badge-divider");
var fecha_1 = __importDefault(require("fecha"));
var menu_context_1 = require("../context/menu-context");
var entity_list_section_1 = require("./entity-list-section");
exports.RecentEntityListDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    margin-top: ", ";\n    list-style: none;\n\n    ", " {\n      &:last-child {\n        padding-bottom: ", "; \n      }\n    }\n\n  "], ["\n    margin: 0;\n    padding: 0;\n    margin-top: ", ";\n    list-style: none;\n\n    ", " {\n      &:last-child {\n        padding-bottom: ", "; \n      }\n    }\n\n  "])), theme_1.theme.UNIT(2), entity_list_1.EntityList.cls.rule('item'), theme_1.theme.UNIT(6))
});
var DateStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: ", " 0 ", " 0;\n  "], ["\n    margin: ", " 0 ", " 0;\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(2, 1))
});
var GroupStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n    font-size: ", ";\n  "], ["\n    margin-top: ", ";\n    font-size: ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.FONT_SIZE(15))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Group: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), GroupStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Date: (0, styled_components_1.default)(badge_divider_1.BadgeDivider)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), DateStyles),
  List: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ListStyles)
};
var prettyDate = function (dateStr) {
  var parsed = fecha_1.default.parse(dateStr, 'YYYY-MM-DD');
  if (!parsed) {
    return;
  }
  var diff = (new Date().getTime() - parsed.getTime()) / 1000;
  var day_diff = Math.floor(diff / 86400);
  if (isNaN(day_diff) || day_diff < 0) return;
  if (day_diff > 31) {
    return fecha_1.default.format(parsed, 'Do MMM YYYY');
  }
  return day_diff == 0 && "Today" || day_diff == 1 && "Yesterday" || day_diff < 7 && day_diff + " days ago" || day_diff < 31 && Math.ceil(day_diff / 7) + " weeks ago";
};
var RecentEntityList = function (props) {
  var className = props.className,
    items = props.items,
    onItemClick = props.onItemClick;
  // const entities = useEntities();
  // const modal = useModal();
  // // filter any results which have an entity type name which isn't supported. (Eventually the server won't emit these)
  // const resultsByDay = groupBy(filter(results, result => (!!entities[result.__typename])), result => formatDateString(result.viewDate, 'YYYY-MM-DD', 'YYYYMMDDHHmmss'));
  // const days = reverse(sortBy(keys(resultsByDay)));
  return react_1.default.createElement(menu_context_1.MenuProvider, {
    value: {
      preventDelete: true
    }
  }, react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.List, {
    orderBy: "",
    title: "",
    maxItems: 4,
    maxDescriptionWords: 40,
    showDescription: true,
    showMenu: true,
    onItemClick: onItemClick,
    items: (0, lodash_1.reverse)((0, lodash_1.sortBy)(items, 'viewDate'))
  })));
};
exports.RecentEntityList = RecentEntityList;
exports.RecentEntityList.defaultProps = exports.RecentEntityListDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;